import React from 'react'
import injectSheet from 'react-jss'
import { MyLoginOauth } from './my-login-oauth'
import { GoogleOauth } from './google-oauth'

export const Oauth = injectSheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  }
})(({ classes }) => {
  return (
    <div className={classes.container}>
      <GoogleOauth />
      <MyLoginOauth />
    </div>
  )
})
